import axios from 'axios';
import ToastService from '@/services/toastService';
import authStore from '@/stores/authModule';
import {backEndUrl} from "@/helpers/siteURL";

const $host = axios.create({
  baseURL: backEndUrl,
});

$host.interceptors.response.use((response) => {
  return response;
}, (error) => {
  const statusCode = error.response.status;

  if (statusCode === 401 || statusCode === 403) {
    authStore.state.isAuth = false;
    localStorage.removeItem('accessToken');

    ToastService.toastError('Ошибка авторизации!');
  } else if (statusCode === 404) {
    const msgError = error.response?.data?.message ?? 'По указанным параметрам ничего не нашлось';
    const currPath = window.location.pathname;
    if (currPath !== '/main') ToastService.toastError(msgError);
  } else {
    const msgError = error.response?.data?.message ?? 'Сервер неисправен';
    if (statusCode === 409) ToastService.toastErrorTimeout(msgError, 10000)
    else ToastService.toastError(msgError);
  }

  return Promise.reject(error);
});

export {
  $host,
};